import { useEffect, useState } from 'react'
import { api, type Notiz } from '../api'
import { tagesDatum, tagesTitel } from '../tagebuch'
import { NotizKarte } from './NotizKarte'

/** Eine einzelne Notiz, z. B. als Ziel eines Quellenverweises. */
export function EinzelneNotiz({ id, kiBereit, onRueckfragen }: { id: number; kiBereit: boolean; onRueckfragen: () => void }) {
  const [notiz, setNotiz] = useState<Notiz | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    api.notiz(id).then(setNotiz).catch((e) => setFehler((e as Error).message))
  }, [id])

  const eigeneZeitzone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return (
    <div className="tagebuch">
      <p className="filter">
        {notiz ? tagesTitel(tagesDatum(new Date(notiz.aufgenommenAm), notiz.zeitzone), tagesDatum(new Date(), eigeneZeitzone)) : 'Notiz'}
        <a href="#tagebuch" aria-label="Zum ganzen Tagebuch">
          ✕
        </a>
      </p>
      {fehler && <p className="fehler">{fehler}</p>}
      {notiz && (
        <NotizKarte notiz={notiz} kiBereit={kiBereit} onGeaendert={setNotiz} onGeloescht={() => (window.location.hash = '#tagebuch')} onRueckfragen={onRueckfragen} />
      )}
    </div>
  )
}
